<template>
  <div class="add-customerName">
    <div class="search">
      <div class="search-left">
        <span class="search-left-title">客户名称：</span>
        <el-input class="white" v-model="customerName" placeholder="请输入名称" />
        <el-button icon="el-icon-search" class="btn-blue" @click="searchData">搜索</el-button>
      </div>
      <div class="add-customer" @click="addCustomer">
        <span class="add-rectangle"></span>
        <span>新增客户</span>
      </div>
    </div>
    <div class="table">
      <el-table :data="tableData" style="width: 100%">
        <el-table-column v-for="(item, tIndex) in tableTitle" :key="tIndex" :prop="item.prop" :label="item.label"
          :min-width="item.width">
          <template slot-scope="scope">
            <div v-if="item.prop === 'code'">
              <span class="code" v-for="(c, cIndex) in scope.row.code" :key="`${tIndex}-${cIndex}`">{{ c }}</span>
            </div>
            <div v-else>
              {{ scope.row[item.prop]}}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" class="btn-text" @click="mod(scope.row)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <pagination-tpl :total="total" :currentPage="currentPage" :pageSize="pageSize"
          @queryChange="queryChange"></pagination-tpl>
      </div>
    </div>
    <!-- 新增/编辑客户 -->
    <el-drawer :title="drawerTitle" :visible.sync="drawer" :wrapperClosable="false" :before-close="handleCloseDrawer">
      <el-form ref="customerForm" :rules="customerFormRules" :model="customerForm">
        <el-form-item label="客户名称" prop="name">
          <el-input v-model="customerForm.name" placeholder="请输入姓名" class="white"></el-input>
        </el-form-item>
        <el-form-item label="客户编码" prop="code">
          <label-input v-model="customerForm.code" :width="448" placeholder="请输入客户编码" />
        </el-form-item>
        <el-form-item label="客户简称" prop="abbreviation">
          <el-input v-model="customerForm.abbreviation" placeholder="请输入客户简称" class="white"></el-input>
        </el-form-item>
        <el-form-item label="联系人" prop="contact">
          <el-input v-model="customerForm.contact" placeholder="请输入联系人" class="white"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="phoneNo">
          <el-input v-model="customerForm.phoneNo" placeholder="请输入手机号" class="white"></el-input>
        </el-form-item>
      </el-form>
      <div class="drawer-footer">
        <el-button class="btn-gray" @click="handleCloseDrawer">取消</el-button>
        <el-button class="btn-blue" @click="submit('customerForm')">确定</el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import PaginationTpl from "components/base/PaginationTpl";
import LabelInput from "components/base/input/label-input";
import ProjectManage from "models/project-manage";
const projectManage = new ProjectManage();
import { formaTimeToMinute } from "common/js/util";
export default {
  data() {
    return {
      customerName: '',
      tableData: [],
      tableTitle: [
        {prop: 'customerName', label: '客户名称', width: ''},
        {prop: 'code', label: '客户编码', width: '200'},
        {prop: 'ordersName', label: '客户简称', width: ''},
        {prop: 'createTime', label: '创建时间', width: ''},
        {prop: 'phoneNo', label: '手机号', width: ''},
        {prop: 'contact', label: '联系人', width: ''},
      ],
      total: 0,
      currentPage: 1,
      pageSize: 20,
      drawer: false,
      drawerTitle: '新增客户',
      customerForm: {
        id: null,
        name: "",
        code: [],
        abbreviation: "",
        phoneNo: "",
        contact: "",
      },
      customerFormRules: {
        name: [{ required: true, message: "请输入客户名称", trigger: "blur" }],
        code: [{ required: true, message: "请输入客户编码", trigger: "blur" }],
        abbreviation: [
          { required: true, message: "请输入客户简写", trigger: "blur" }
        ]
      },
    };
  },
  components: {
    PaginationTpl,
    LabelInput
  },
  created() {
    this.initCustomerList()
  },
  methods: {
    addCustomer() {
      this.drawerTitle = '新增客户'
      this.drawer = true;
    },
    mod(row) {
      this.drawerTitle = '编辑客户'
      this.customerForm.id = row.id
      this.customerForm.name = row.customerName
      this.customerForm.code = row.code
      this.customerForm.abbreviation = row.ordersName
      this.customerForm.phoneNo = row.phoneNo
      this.customerForm.contact = row.contact
      this.drawer = true;
    },
    //获取列表
    initCustomerList() {
      let pageNo = this.currentPage;
      let queryStr = this.customerName;
      projectManage
        .getCustomerList(pageNo, queryStr)
        .then(res => {
          if (res.success) {
            let tableData = [];
            this.pageSize = res.result.pageSize;
            this.total = res.result.totalNum;
            res.result.items.map(value => {
              let obj = {};
              obj.id = value.id;
              obj.customerName = value.name;
              obj.ordersName = value.ordersName;
              obj.status = value.status;
              let codeArr = []
              let code = value.code
              if (code) {
                codeArr = code.split(',')
              }
              obj.code = codeArr;
              obj.createTime = value.createTime == 0 ? '':formaTimeToMinute(value.createTime);
              obj.phoneNo	= value.phoneNo;
              obj.contact	= value.contact;
              tableData.push(obj);
            });
            this.tableData = tableData;
          }
        });
    },
    searchData() {
      this.currentPage = 1
      this.initCustomerList();
    },
    queryChange(data) {
      this.currentPage = data.currentPage;
      this.initCustomerList();
    },
    handleCloseDrawer() {
      this.customerForm.id = ""
      this.customerForm.name = ""
      this.customerForm.code = []
      this.customerForm.abbreviation = ""
      this.customerForm.phoneNo = ""
      this.customerForm.contact = ""
      this.drawer = false;
      this.initCustomerList()
    },
    /* 保存客户 */
    submit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let data = {};
          data.id = this.customerForm.id;
          data.name = this.customerForm.name;
          data.code = this.customerForm.code.join();
          data.phoneNo = this.customerForm.phoneNo;
          data.contact = this.customerForm.contact;
          data.ordersName = this.customerForm.abbreviation;
          projectManage.postAddCustomer(data).then(res => {
            if (res.success) {
              this.handleCloseDrawer();
              this.initCustomerList();
            } else {
              this.$message({
                type: 'error',
                message: res.message
              })
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    }, 
  }
};
</script>
<style lang="scss">
@import '@/assets/style/layout/system/customer-list.scss';
</style>

